module.exports = __webpack_public_path__ + "img/Melda-nologo.777410d6.png";